import { render, staticRenderFns } from "./StandardProtocol.vue?vue&type=template&id=b1913d02&scoped=true"
import script from "./StandardProtocol.vue?vue&type=script&lang=js"
export * from "./StandardProtocol.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1913d02",
  null
  
)

export default component.exports